const agentType = {
    isWx: undefined,
    isIphone: undefined,
    isMobile: undefined
};
function isWeixin() {
    var _a;
    return (_a = agentType.isWx) !== null && _a !== void 0 ? _a : (agentType.isWx = /MicroMessenger/i.test(window.navigator.userAgent));
}
function isIphone() {
    var _a;
    return (_a = agentType.isIphone) !== null && _a !== void 0 ? _a : (agentType.isIphone = /iPhone/i.test(window.navigator.userAgent));
}
function isMobile() {
    var _a;
    return (_a = agentType.isMobile) !== null && _a !== void 0 ? _a : (agentType.isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent));
}
export { isWeixin, isIphone, isMobile };
